import React, { useContext, useEffect, useState } from 'react';
import './BoxMatrix.css';
import * as PROJECT_CODE from '../../constants/projectCode';
import { FirebaseContext } from '../../context/firebase';
import { makeStyles, Paper, Tab, Tabs, withStyles } from '@material-ui/core';
import PhoneIcon from '@material-ui/icons/Phone';
import PersonIcon from '@material-ui/icons/Person';
import DraftsIcon from '@material-ui/icons/Drafts';
import CloseIcon from '@material-ui/icons/Close';
import { Person } from '@material-ui/icons';
import Modal from '../layout/modal/Modal';
import Clients from '../clients/Clients';
import CallFurioos from '../videoCall/FurioosController';
import ClearIcon from '@material-ui/icons/Clear';
import Chart from './Chart';

function BoxMatrix() {
	const { firebase } = useContext(FirebaseContext);
	const [blockA, setBlockA] = useState([]);
	const [tabValue, setTabValue] = useState(0);
	const [blocks, setBlocks] = useState([]);
	const [tooltipContent, setTooltipContent] = useState();
	const [show, setShow] = useState(false);
	const [showModel, setShowModel] = useState(false);

	useEffect(() => {
		function onlyUnique(value, index, self) {
			return self.indexOf(value) === index;
		}
		//getting blocks
		firebase
			.database()
			.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/lots/')
			.once('value', (snapshot) => {
				var blockArr = [];
				var uniqueBlockArr;
				snapshot.forEach((block) => {
					var block = block.val().block;

					blockArr.push(block);
				});

				uniqueBlockArr = blockArr.filter(onlyUnique);

				setBlocks(uniqueBlockArr);
			});

		//getting blocks A objects (default view)
		firebase
			.database()
			.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/lots/')
			.orderByChild('block')
			.equalTo('A')
			.once('value', (snapshot) => {
				console.log('Snapshot: ' + JSON.stringify(snapshot));
				var lotObj;
				var lotArr = [];
				snapshot.forEach((lot) => {
					var availablity = lot.val()?.available;
					var lotId = lot.key;
					var lotPrice = lot.val()?.lotPrice;
					var salesAgent = lot.val()?.salesAgent;

					console.log('lotPrice: ' + lotPrice);

					firebase
						.database()
						.ref('/kavtek_clients/' + PROJECT_CODE.projectCode)
						.once('value', (snapshot) => {
							var mattSnap = snapshot.child('matterport');
						});

					lotObj = {
						availability: availablity,
						lotId: lotId,
						premium: lotPrice,
						salesAgent: salesAgent,
					};

					console.log('lotobj: ' + JSON.stringify(lotObj));

					lotArr.push(lotObj);
				});

				setBlockA(lotArr);
			});
	}, []);

	const handleTab = (e) => {
		var blockId = e.currentTarget.dataset.id;

		firebase
			.database()
			.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/lots/')
			.orderByChild('block')
			.equalTo(blockId)
			.once('value', (snapshot) => {
				console.log('Snapshot: ' + JSON.stringify(snapshot));
				var lotObj;
				var lotArr = [];
				snapshot.forEach((lot) => {
					var availablity = lot.val()?.available;
					var lotId = lot.key;
					var lotPrice = lot.val()?.lotPrice;

					lotObj = {
						availability: availablity,
						lotId: lotId,
						premium: lotPrice,
					};

					lotArr.push(lotObj);
				});

				setBlockA(lotArr);
			});
	};

	const handleTabChange = (event, newValue) => {
		setTabValue(newValue);
	};

	const handleTooltip = (e) => {
		var lotId = e.currentTarget.dataset.id;
		var availability = e.currentTarget.dataset.availability;
		var premium = e.currentTarget.dataset.premium;
		var salesAgent = e.currentTarget.dataset.agents;

		var tooltipObj = {
			lotId: lotId,
			availability: availability,
			premium: premium,
			salesAgent: salesAgent,
		};

		setTooltipContent(tooltipObj);
	};

	const handleCloseTooltip = () => {
		setTooltipContent();
	};

	const handleSelectLot = () => {
		setShow(true);
	};

	const handleViewModel = (e) => {
		var projectId = e.currentTarget.dataset.id;

		var furioosCaller = new CallFurioos();

		async function furioos() {
			await setShowModel(true);
			var currentUserId = firebase.auth().currentUser.uid;
			var userEmail;
			var userName;
			var userTime = Date.now();
			await firebase
				.database()
				.ref('users')
				.child(currentUserId)
				.once('value', (snapshot) => {
					userEmail = snapshot.val().email;
					userName = snapshot.val().displayName;
				});

			await furioosCaller.startFurioos(
				userEmail,
				userName,
				'',
				'e5fe5968-058c-494b-8e8f-ca95425a2a02',
				userTime,
				'',
				'admin',
				currentUserId,
				currentUserId,
				'',
				'furioosContainer_homes',
				projectId
			);
		}

		furioos();
	};

	const closeModalHandler = () => {
		setShow(false);
	};

	const handleCloseModel = () => {
		setShowModel(false);
	};

	const useStyles = makeStyles(() => ({
		paper: {
			width: '51em',
		},
		elevationTab: {
			backgroundColor: '#F1F5F8',
			boxShadow: '0px 1px 8px rgba(20, 46, 110, 0.1)',
			borderRadius: '8px',
		},
		tooltipPaper: {
			paddingBottom: '10px',
			position: 'relative',
		},
		tooltipIcon: {
			color: '#999999',
		},
		tooltipCloseBtn: {
			position: 'absolute',
			top: '8px',
			right: '0',
		},
	}));

	const StyledTabs = withStyles({
		indicator: {
			display: 'flex',
			justifyContent: 'center',
			backgroundColor: 'transparent',
		},
	})((props) => (
		<Tabs
			{...props}
			TabIndicatorProps={{ children: <span /> }}
			variant='scrollable'
		/>
	));

	const StyledTab = withStyles((theme) => ({
		root: {
			textTransform: 'none',
			color: '#2662F0',
			textTransform: 'uppercase',
			'&.Mui-selected': {
				backgroundColor: '#e4e4e4',
				boxShadow: '0px 1px 8px rgba(20, 46, 110, 0.1)',
				borderRadius: '8px',
				color: '#2662F0',
			},
		},
	}))((props) => <Tab {...props} />);

	const setLotStyle = (availability) => {
		if (availability === 'available') {
			return { backgroundColor: 'green' };
		} else if (availability === 'pending') {
			return { backgroundColor: 'yellow' };
		} else if (availability === 'soldout') {
			return { backgroundColor: 'red', color: 'white' };
		}
	};

	const styles = useStyles();

	return (
		<>
			{showModel && (
				<div id='furioosContainer_homes'>
					<div className='cancelBtn' onClick={handleCloseModel}>
						<ClearIcon className='cancelIcon' />
					</div>
				</div>
			)}
			<div className='box-matrix-page'>
				<h2 id='client-title'>Box Matrix</h2>
				<br />
				<div className='box-wrapper'>
					<Paper className={styles.paper}>
						<div className='block-wrapper'>
							<StyledTabs value={tabValue} onChange={handleTabChange} centered>
								{blocks?.map((block) => {
									return (
										<StyledTab
											label={'Block ' + block}
											data-id={block}
											onClick={(e) => handleTab(e)}
										/>
									);
								})}
							</StyledTabs>
							{blockA?.map((lot) => {
								return (
									<>
										<div
											className='lot-square'
											style={{ ...setLotStyle(lot.availability) }}
											data-id={lot.lotId}
											data-availability={lot.availability}
											data-agents={lot.salesAgent}
											data-premium={lot.premium}
											onClick={(e) => handleTooltip(e)}
										>
											{lot.lotId}
										</div>
										<Modal
											show={show}
											close={closeModalHandler}
											title='Choose a client and create a document '
											buttonName='Close'
											button={closeModalHandler}
										>
											<Clients lotId={lot.lotId} />
										</Modal>
									</>
								);
							})}
						</div>
					</Paper>
					{tooltipContent && (
						<div className='appointment-detail'>
							<Paper className={styles.tooltipPaper}>
								<div onClick={handleCloseTooltip}>
									<CloseIcon className={styles.tooltipCloseBtn} />
								</div>
								<h2 className='tooltip-title'>Lot Details</h2>
								<div className='tooltip-field'>
									<p className='tooltip-handle'>Lot Id: </p>
									<p className='tooltip-label'>{tooltipContent?.lotId}</p>
								</div>
								<div className='tooltip-field'>
									<p className='tooltip-handle'>Lot Status: </p>
									<p className='tooltip-label'>
										{tooltipContent?.availability}
									</p>
								</div>
								<div className='tooltip-field'>
									<p className='tooltip-handle'>Premium: </p>
									<p className='tooltip-label'>${tooltipContent?.premium}</p>
								</div>
								<div
									className={
										tooltipContent?.availability === 'soldout' ||
										tooltipContent?.availability === 'pending'
											? 'tooltip-actions display-none'
											: 'tooltip-actions'
									}
								>
									<button className='tooltip-join' onClick={handleSelectLot}>
										Select Lot
									</button>
									<button
										className='tooltip-join'
										data-id='415.637'
										onClick={(e) => handleViewModel(e)}
									>
										View 3D Model
									</button>
								</div>
								{tooltipContent?.availability === 'pending' && (
									<div className='tooltip-field'>
										<p className='tooltip-handle'>Assigned agent: </p>
										<p className='tooltip-label'>
											{tooltipContent?.salesAgent}
										</p>
									</div>
								)}
							</Paper>
						</div>
					)}
				</div>

				<Chart />
			</div>
		</>
	);
}

export default BoxMatrix;
